import styled from '@emotion/styled';
import {
  background,
  border,
  color,
  compose,
  display,
  flexbox,
  layout,
  position,
  shadow,
  space,
  typography,
  BackgroundProps,
  BorderProps,
  DisplayProps,
  FlexboxProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system';
import { ColorProps, defineWithTheme } from '../../theming';
export interface ListItemProps
  extends BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

export const ListItem = styled('li')<ListItemProps>(
  defineWithTheme('listItems'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    shadow,
    space,
    typography
  )
);
